import React from "react";
import { LayoutPortalContext } from "../../components/Layout";

/**
 * Hook to access the LayoutPortalContext value.
 *
 * @returns The LayoutPortalContext value.
 * @throws Will throw an error if used outside of a LayoutPortalContext provider.
 */
function useLayoutPortal() {
  const layoutPortal = React.useContext(LayoutPortalContext);

  if (layoutPortal === undefined) {
    throw new Error(
      "useLayoutPortal must be used within a LayoutPortalContext provider."
    );
  }

  return {
    leftContainer: layoutPortal.leftContainer,
    rightContainer: layoutPortal.rightContainer,
    bannerContainer: layoutPortal.bannerContainer,
    isFpsLimitExceeded: layoutPortal.isFpsLimitExceeded,
    setIsFpsLimitExceeded: layoutPortal.setIsFpsLimitExceeded,
  };
}

export default useLayoutPortal;
